import { TableCols } from '../interfaces/static-data';
import {Validators} from "@angular/forms";
import {PRODUCT_TYPE} from "../../../product-capture/model/consts/product-type.conts";

export const PRODUCT_SUB_TYPE: TableCols[] = [
  {
    key: 'subTypeName',
    displayValue: 'Sub Type name',
    validators: [Validators.required]
  },
  {
    key: 'productFamily',
    displayValue: 'Product Family',
  },
  {
    key: 'productType',
    displayValue: 'Product Type',
    type: 'select',
    items: PRODUCT_TYPE,
    validators: [Validators.required]
  },
  {
    key: 'marketingNames',
    displayValue: 'Marketing Names',
    validators: [Validators.required, Validators.minLength(1)]
  },
  {
    key: 'tenants',
    displayValue: 'Tenants',
  },
  {
    key: 'legalProgrammeId',
    displayValue: 'Legal Programme ID',
    type: 'number',
  },
  {
    key: 'codes',
    displayValue: 'Codes'
  },
  {
    key: 'lastUpdatedBy',
    displayValue: 'Last Updated By',
    hideOnForm: true
  },
  {
    key: 'updatedOn',
    displayValue: 'Updated On',
    hideOnForm: true
  }
];
